import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { NewsData } from './news.model';
import { NewsService } from './news.service';

export class NewsDataSource implements DataSource<NewsData> {

  private dataSubject = new BehaviorSubject<NewsData[]>([]);
  private dataLengthSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public data = this.dataSubject.asObservable();
  public dataLength = this.dataLengthSubject.asObservable();
  public loading = this.loadingSubject.asObservable();

  constructor(private newsService: NewsService) {}

  connect(collectionViewer: CollectionViewer): Observable<NewsData[]> {
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.dataSubject.complete();
    this.loadingSubject.complete();
  }

  loadNewsItems(
    pageIndex: number,
    pageSize: number,
    sortBy: string = 'createdAt',
    sortDirection: string = 'asc',
    filter: string = '',
  ) {

    this.loadingSubject.next(true);

    this.newsService
      .findPaginated(
        pageIndex,
        pageSize,
        sortBy,
        sortDirection,
        filter
      )
      .pipe(
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(data => {
        this.dataSubject.next(data._embedded.news);
        this.dataLengthSubject.next(data.total_items);
      });
  }
}
